export default __webpack_public_path__ + "static/media/Oluwatobiloba.cf63b1ba.jpg";